import http from './HttpService';
import { mapFormDataWithStringify } from './AutomationServices';
import { IActionData, IFieldData, IFormAudienceParams, IUpdateAction } from 'modules/Settings/Forms/interfaces';
import { API_BASE_AUDIENCE, API_BASE_CAMPAIGN } from '../../constants/index';
import store from 'store';
import axios from 'axios';

// Forms Listing
let cancelTokenForms: any;
export async function getFormsService(params: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenForms != typeof undefined) {
    cancelTokenForms && cancelTokenForms.cancel('Operation canceled due to new request.');
  }
  //Save the cancel token for the current request
  cancelTokenForms = axios.CancelToken.source();

  return await http.get(`${API_BASE_CAMPAIGN}get_user_forms/?${params}`, {
    cancelToken: cancelTokenForms.token,
  });
}

// Create Form
export async function createNewFormService(
  formName: string,
  formActions: IActionData[],
  formFields: IFieldData,
  formCampaignId?: string,
  event_type?: string,
) {
  const payload = new FormData();
  if (formName.trim() !== '') {
    payload.append('form_name', formName);
  }
  if (formCampaignId && formCampaignId !== '0') {
    payload.append('form_campaign_id', formCampaignId);
  }
  payload.append('form_actions', JSON.stringify(formActions));
  payload.append('form_fields', JSON.stringify(formFields));
  if (event_type) payload.append('event_type', event_type);
  return await http.post(`${API_BASE_CAMPAIGN}create_form/`, payload);
}

// Update Form
export async function updateFormService(
  formId: string,
  formName: string,
  formActions: IUpdateAction,
  formFields: IFieldData,
  formCampaignId?: string,
) {
  const payload = new FormData();
  payload.append('form_id', formId);
  if (formName.trim() !== '') {
    payload.append('form_name', formName);
  }
  if (formCampaignId && formCampaignId !== '0') {
    payload.append('form_campaign_id', formCampaignId);
  }
  payload.append('form_actions', JSON.stringify(formActions));
  payload.append('form_fields', JSON.stringify(formFields));
  return await http.post(`${API_BASE_CAMPAIGN}update_form/`, payload);
}

// Delete Form
export async function deleteFormService(formIds: number[], selectAll?: boolean, excludedFormIds?: number[], searchTerm?: string) {
  const payload = new FormData();
  const data = mapFormDataWithStringify({ formIds, excludedFormIds });
  const formIdsArray = data.get('formIds');
  const excludedFormIdsArray = data.get('excludedFormIds');
  if (selectAll) {
    payload.append('select_all', selectAll.toString());
    if (searchTerm && searchTerm.length > 0) payload.append('search_term', searchTerm);
    if (excludedFormIdsArray !== null && excludedFormIds && excludedFormIds.length !== 0) payload.append('excluded_form_ids', excludedFormIdsArray);
  } else {
    if (formIdsArray !== null) payload.append('form_ids', formIdsArray);
  }
  return await http.post(`${API_BASE_CAMPAIGN}delete_form/`, payload);
}

// Form Details
export const getFormDetailsService = async (formId: number) => {
  return await http.get(`${API_BASE_CAMPAIGN}get_form_details/?form_id=${formId}`, {});
};

// Get audience who submitted the form
export const getFormAudienceService = async (params: IFormAudienceParams) => {
  let baseURL = `${API_BASE_AUDIENCE}get_form_audience/?offset=${params.offset}&limit=${params.limit}&form_id=${params.formId}`;
  if (params.searchTerm) baseURL += `&search_term=${encodeURIComponent(params.searchTerm)}`;
  if (params.sortBy) baseURL += `&sort_by=${params.sortBy}`;
  if (params.sortType) baseURL += `&sort_type=${params.sortType}`;
  if (params.startDate) baseURL += `&start_date=${params.startDate}`;
  if (params.endDate) baseURL += `&end_date=${params.endDate}`;
  baseURL += '&event_type=View_Contacts_Under_Form_Handler';
  return await http.get(baseURL, {});
};

export const formAudienceCreateNewListService = async (params: IFormAudienceParams) => {
  const { first_name, last_name } = store.getState().user.userData;
  const newListName = `${first_name} ${last_name} New List ${new Date().toUTCString()}`.replace(',', ' ');

  let baseURL = `${API_BASE_AUDIENCE}get_form_audience/`;
  const payload = new FormData();
  // Mandatory Params
  payload.append('form_id', JSON.stringify(params.formId));
  payload.append('list_name', newListName);
  payload.append('start_date', params.startDate as string);
  payload.append('end_date', params.endDate as string);
  // Optional Params
  if (params.searchTerm) payload.append('search_term', params.searchTerm as string);
  return await http.post(baseURL, payload);
};
